var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ci-icon',{staticClass:"gl-mb-2",attrs:{"status":_vm.pipelineStatus,"show-status-text":""},on:{"ciStatusBadgeClick":_vm.trackClick}}),_vm._v(" "),_c('pipelines-timeago',{attrs:{"pipeline":_vm.pipeline}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }